import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['statusName', 'statusId', 'addButton'];

  connect() {
    this.rowTemplate = this.element.querySelector('[data-template="row"]');
    this.rowsSection = this.element.querySelector('.rows-section');
  }

  addStatus(event) {
    event.preventDefault();
    const statusName = this.statusNameTarget.value;
    const statusId = this.statusIdTarget.value;
    const temp = document.createElement('div');

    temp.appendChild(this.rowTemplate.content.cloneNode(true));
    temp.firstElementChild.children[0].textContent = statusName;
    temp.firstElementChild.children[1].textContent = statusId;

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `integration[config][completion_codes][${statusName}]`;
    input.value = statusId;
    temp.firstElementChild.appendChild(input);

    this.statusNameTarget.value = '';
    this.statusIdTarget.value = '';

    this.rowsSection.appendChild(temp.firstElementChild);
    this.addButtonTarget.disabled = true;
  }

  deleteStatus(event) {
    event.preventDefault();
    event.target.closest('.js-table-body-row').remove();
  }

  toggleAddButton() {
    if (this.statusNameTarget.value && this.statusIdTarget.value) {
      this.addButtonTarget.disabled = false;
    } else {
      this.addButtonTarget.disabled = true;
    }
  }
}
